import { render, staticRenderFns } from "./ElDescription.vue?vue&type=template&id=f9f45d32&scoped=true"
import script from "./ElDescription.vue?vue&type=script&lang=js"
export * from "./ElDescription.vue?vue&type=script&lang=js"
import style0 from "./ElDescription.vue?vue&type=style&index=0&id=f9f45d32&prod&scoped=true&lang=scss"
import style1 from "./ElDescription.vue?vue&type=style&index=1&id=f9f45d32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f45d32",
  null
  
)

export default component.exports